import { CancelablePromise, OpenAPI, request as __request } from '/src/api';
import { Headlines } from '/src/lib/models';
import type { TGetHeadlinesRequest, TGetHeadlinesResponse } from '/src/lib/types';

export class HeadlinesService {
  /**
   * Formats/calculates Headlines response data
   */
  private static _interceptor = (headlines: Headlines) => {
    if (!headlines.assetCredit) headlines.assetCredit = 0;
    if (!headlines.assetValue) headlines.assetValue = 0;
    if (!headlines.availableCredit) headlines.availableCredit = 0;
    if (!headlines.feesDue) headlines.feesDue = 0;
    if (!headlines.feesPaid) headlines.feesPaid = 0;
    if (!headlines.interestDue) headlines.interestDue = 0;
    if (!headlines.interestPaid) headlines.interestPaid = 0;
    if (!headlines.principalBalance) headlines.principalBalance = 0;
    if (!headlines.totalRevenue) headlines.totalRevenue = 0;

    // Return
    return headlines;
  };

  /**
   * Get Headlines
   * @param id TReportId
   * @returns Report
   * @throws ApiError
   */
  public static async get(req: TGetHeadlinesRequest): CancelablePromise<TGetHeadlinesResponse> {
    return this._interceptor(
      await __request(OpenAPI, {
        method: 'GET',
        url: '/reports/headlines',
        query: req,
      })
    );
  }
}
